<pin-page [backLink]="true">
  <pin-page-title [type]="PageTitleType.H1" id="main-content" tabIndex="-1" role="complementary" aria-label="view and download documents">
    <pin-documents-title [showStatements]="showStatements" [showNotices]="showNotices" [showTaxDocuments]="showTaxDocuments" align="justify-start" [showIcon]="false"></pin-documents-title>
  </pin-page-title>
  <pin-page-content role="main">
    <div class="dcp-tab-container border-default mt-8 box-shadow-sm">
      @if (showStatements && showTaxDocuments || showNotices) {
        <pin-navtab id="statements-and-tax-forms-nav" [routes]="routes" [stretch]="true"
                    ariaLabel="statements and tax forms navigation tab" [tabPanel]="tabPanel"></pin-navtab>
      }
      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </div>
  </pin-page-content>
</pin-page>
